import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TradingPage = lazy(() => import('../pages/trading/page'));
const SwapPage = lazy(() => import('../pages/swap/page'));
const BuyPage = lazy(() => import('../pages/buy/page'));
const TransactionsPage = lazy(() => import('../pages/transactions/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ApiIntegrationPage = lazy(() => import('../pages/api-integration/page'));
const TravelRulePage = lazy(() => import('../pages/travel-rule/page'));
const SecurityPage = lazy(() => import('../pages/security/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const FeesPage = lazy(() => import('../pages/fees/page'));
const P2PPage = lazy(() => import('../pages/p2p/page'));
const DemoTradingPage = lazy(() => import('../pages/demo-trading/page'));
const DEXPage = lazy(() => import('../pages/dex/page'));
const ConvertBlockTradePage = lazy(() => import('../pages/convert-block-trade/page'));
const AlphaPage = lazy(() => import('../pages/alpha/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const IntegrationsPage = lazy(() => import('../pages/integrations/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/trading',
    element: <TradingPage />,
  },
  {
    path: '/swap',
    element: <SwapPage />,
  },
  {
    path: '/buy',
    element: <BuyPage />,
  },
  {
    path: '/p2p',
    element: <P2PPage />,
  },
  {
    path: '/demo-trading',
    element: <DemoTradingPage />,
  },
  {
    path: '/dex',
    element: <DEXPage />,
  },
  {
    path: '/convert-block-trade',
    element: <ConvertBlockTradePage />,
  },
  {
    path: '/alpha',
    element: <AlphaPage />,
  },
  {
    path: '/transactions',
    element: <TransactionsPage />,
  },
  {
    path: '/settings',
    element: <SettingsPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/api-integration',
    element: <ApiIntegrationPage />,
  },
  {
    path: '/integrations',
    element: <IntegrationsPage />,
  },
  {
    path: '/travel-rule',
    element: <TravelRulePage />,
  },
  {
    path: '/security',
    element: <SecurityPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/fees',
    element: <FeesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
